import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { ROUTES } from '../../../../../../constants/routes';
import { styleSheet } from '../styles';

type Props = {
	contact: Api.IContact;
};

export const JobTitleInfo = ({ contact }: Props) => {
	const companyId = useMemo(() => {
		if (!contact) {
			return null;
		}

		return contact.company ? contact.company.id : null;
	}, [contact]);

	if (!contact) {
		return null;
	}

	const { jobTitle, companyName } = contact;

	if (!jobTitle && !companyName) {
		return null;
	}

	return (
		<div className={css(styleSheet.jobTitleContainer)}>
			{Boolean(jobTitle) && <span>{jobTitle}</span>}
			{Boolean(jobTitle) && Boolean(companyName) && <span>&nbsp;at&nbsp;</span>}
			{Boolean(companyName) &&
				(companyId ? (
					<NavLink
						className={`brand-link truncate-text ${css(styleSheet.companyLink)}`}
						to={`${ROUTES.contacts.companies}/${companyId}`}
					>
						{companyName}
					</NavLink>
				) : (
					<span className={`truncate-text ${css(styleSheet.companyLink)}`}>{companyName}</span>
				))}
		</div>
	);
};
